<div mat-button [matMenuTriggerFor]="menu" class="mb-2 cursor-pointer" i18n-title title="Zobraziť ďalšie možnosti">
    <a><b>{{statnaSkuska.predmetSkratka}} - {{statnaSkuska.predmetNazov}}</b></a>
    <div *ngIf="statnaSkuska.typ">{{statnaSkuska.typ}}</div>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>

    <div><span class="fw-bold" i18n>Prihlasovanie</span>: {{getPrihlasovanie(statnaSkuska)}}</div>

    <div><span class="fw-bold" i18n>Odhlasovanie</span>: {{getOdhlasovanie(statnaSkuska)}}</div>

    <div *ngIf="statnaSkuska.datumZaradenia">
      <span class="fw-bold" i18n>Dátum zaradenia</span>: {{statnaSkuska.datumZaradenia}}
    </div>
    <div *ngIf="!statnaSkuska.datumZaradenia"><span class="fw-bold" i18n>Dátum zaradenia</span>: <span i18n>neurčený</span></div>
    <div *ngIf="statnaSkuska.miestnost"><span class="fw-bold" i18n>Miestnosť</span>: {{statnaSkuska.miestnost}}</div>
    <div *ngIf="!statnaSkuska.miestnost"><span class="fw-bold" i18n>Miestnosť</span>: <span i18n>neurčená</span></div>

    <!-- komisia -->
    <div *ngIf="statnaSkuska.komisia"><span class="fw-bold" i18n>Komisia</span>: <span>{{statnaSkuska.komisia}}</span></div>
    <div *ngIf="!statnaSkuska.komisia"><span class="fw-bold" i18n>Komisia</span>: <span i18n>neurčená</span></div>

    <div *ngIf="statnaSkuska.poznamka"><span class="fw-bold" i18n>Poznámka</span>: {{statnaSkuska.poznamka}}</div>

    <div class="mt-2" *ngIf="statnaSkuska.hodnotenie"><ul><li><span i18n>Hodnotenie</span>: {{statnaSkuska.hodnotenie}}</li></ul></div>

  <ul class="mt-3">
    <li *ngIf="statnaSkuska.zaevidovanaZiadostUznania">
      <b><span i18n>Zaevidovaná žiadosť o uznanie</span></b>
    </li>
    <li *ngIf="statnaSkuska.ziadostUznana">
      <b><span i18n>Žiadosť uznaná</span></b>
    </li>
  </ul>
</div>

<mat-menu #menu="matMenu">

  <button mat-menu-item class="small" (click)="odhlasitTermin()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Odhlásiť z termínu</span>
  </button>

  <hr/>

  <button mat-menu-item class="small" (click)="nastavitPreferovanyDen()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Nastaviť preferovaný deň</span>
  </button>

  <button mat-menu-item class="small" (click)="obsahovaNaplnPredmetu()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Obsahová náplň predmetu</span>
  </button>

  <button mat-menu-item class="small" (click)="otazkyPredmetuVyjadrenieKomisie()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Otázky predmetu, vyjadrenie komisie</span>
  </button>
  <hr/>
  <button *ngIf="!statnaSkuska.zaevidovanaZiadostUznania" mat-menu-item class="small" (click)="zaevidovatZiadostUznanie()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Zaevidovať žiadost o uznanie</span>
  </button>
  <button *ngIf="statnaSkuska.zaevidovanaZiadostUznania" mat-menu-item class="small" (click)="zrusitZiadostUznanie()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Zrušiť žiadost o uznanie</span>
  </button>
</mat-menu>

